/**
 * Customer "Reopen" mutation. Hits POST /tickets/{n}/reopen.
 *
 * The server only accepts reopen on resolved / closed tickets; the
 * button is hidden in other states (TicketDetailCustomerPage).
 */
import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from "@tanstack/react-query";

import api from "@/lib/api";
import type { TicketResponse } from "@/types/api";

import { ticketDetailQueryKey } from "./useTicketDetail";

export function useReopenTicket(
  ticketNumber: number,
): UseMutationResult<TicketResponse, Error, void> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const response = await api.post<TicketResponse>(
        `/tickets/${ticketNumber}/reopen`,
      );
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ticketDetailQueryKey(ticketNumber),
      });
      void queryClient.invalidateQueries({ queryKey: ["tickets", "list"] });
    },
  });
}
